<script setup lang="ts">
import { AuthenticationError, AuthorizationError, type V1GetOptions } from "@gasparigit/omnia-sdk";
import Help from "~/components/icons/Help.vue";
import { processError } from "~/lib/utils/errors";

const omniaSdk = useOmniaSdk();

const page = usePage();
const options = ref<V1GetOptions>({
  order_mode: "desc",
});

const mode = ref<string>((useRoute().query["mode"] as string) || "all");
watch(mode, () => {
  useRouter().replace({ query: { ...useRoute().query, mode: mode.value } });
});

const areasFilter = ref<string[]>();

const { data, refresh } = await useAsyncData(`all-quesiti`, async () => {
  try {
    if (mode.value === "all") return await omniaSdk.v1.contents.list({ areas: areasFilter.value }, "quesiti", { pagination: "classic", page: page.value }, options.value);

    return await omniaSdk.v1.userQuestions.list({ pagination: "classic", page: page.value }, { order_mode: options.value.order_mode, areas: areasFilter.value });
  } catch (error) {
    if (error instanceof AuthorizationError || error instanceof AuthenticationError) {
      return { allowed: false };
    }
    processError(error);
  }
});

const { data: loggedUser } = useLoggedUser(null);

watch(options.value, () => {
  refresh();
});

watch(mode, () => {
  refresh();
});

const sendQuestionDialogOpened = ref<boolean>(false);
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title: 'Quesiti' }]" title="Quesiti" :search="true" :search-filters="{ front_content_type: ['quesiti'] }" :icon="Help"></FrontBreadcrumHero>

  <div class="main-content mb-10">
    <FrontContentsList title="Quesiti" :icon="Help" :link-config="{}" v-model:data="data" v-model:page="page" @update:page="refresh()" :show-areas="true">
      <template #cta v-if="loggedUser">
        <FrontSendQuestionDialog v-model:opened="sendQuestionDialogOpened" @success="(sendQuestionDialogOpened = false), (mode = 'inviati'), refresh()">
          <Button>Poni il tuo quesito</Button>
        </FrontSendQuestionDialog>
      </template>
      <template #side>
        <Form>
          <FrontRadioGroupCard
            base-key="question-type"
            v-model="mode"
            :icon="Help"
            title="Filtra quesiti"
            :options="[
              { value: 'all', label: 'Quesiti pubblici' },
              { value: 'inviati', label: 'I miei quesiti' },
            ]"
          />

          <FrontAreasFilter class="mb-5" name="area" v-model="areasFilter" @update:model-value="refresh()" />

          <FrontRadioGroupCard base-key="order" v-model="options.order_mode"></FrontRadioGroupCard>
        </Form>
      </template>
    </FrontContentsList>
  </div>
</template>
